import React, { useCallback, useEffect } from 'react';
import { shape, required } from '@totalsoft/pure-validations';
import { useDirtyFieldValidation } from '@totalsoft/pure-validations-react';
import { get, set } from '@totalsoft/change-tracking-react';
import PropTypes from 'prop-types';
import { useChangeTrackingLens } from '@totalsoft/change-tracking-react';
import CommentComponent from './CommentComponent';

const validator = shape({ freeTxt: required });

const CommentContainer = ({ comment, processing, onSave, onDelete, readOnly }) => {
  const [lens, , resetLens] = useChangeTrackingLens({});
  const [validation, validate] = useDirtyFieldValidation(validator);

  useEffect(() => {
    if (comment) {
      resetLens(comment);
    }
  }, [comment, resetLens]);

  /* Handlers */

  const handleValidateAndSave = useCallback(() => {
    if (!validate(lens |> get)) {
      return;
    }
    const { stateId, userId, internalTime, freeTxt } = lens |> get;
    onSave({ stateId, userId, internalTime, freeTxt });
  }, [lens, onSave, validate]);

  const handleChange = useCallback(
    value => {
      const updatedComment = { ...(lens |> get), freeTxt: value };
      (lens |> set)(updatedComment);
      validate(updatedComment);
    },
    [lens, validate]
  );

  /* End Handlers */

  return (
    <>
      <CommentComponent
        commentLens={lens}
        processing={processing}
        onSave={handleValidateAndSave}
        onChange={handleChange}
        onDelete={onDelete}
        validation={validation}
        readOnly={readOnly}
      />
    </>
  );
};

CommentContainer.propTypes = {
  comment: PropTypes.object.isRequired,
  processing: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired
};

export default CommentContainer;
